<template>
    <layout title="Documents &amp; Financials">
        <ul class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2">
            <li class="col-span-1 bg-white rounded-lg border border-blue-200 divide-y divide-gray-200">
                <div class="w-full flex items-center text-center justify-center p-6 space-x-6">
                    <h3 class="text-gray-900 text-xl font-medium">Current Financial Statement</h3>
                </div>
                <div>
                    <div class="-mt-px flex divide-x divide-gray-200">
                        <div class="w-0 flex-1 flex">
                            <a :href="`/storage/current-financial-statement.pdf?${Date.now()}`" target="_blank" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                                <span class="ml-3">View File</span>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
            <li class="col-span-1 bg-white rounded-lg border border-blue-200 divide-y divide-gray-200">
                <div class="w-full flex items-center text-center justify-center p-6 space-x-6">
                    <h3 class="text-gray-900 text-xl font-medium">Year End Financial Statement</h3>
                </div>
                <div>
                    <div class="-mt-px flex divide-x divide-gray-200">
                        <div class="w-0 flex-1 flex">
                            <a :href="`/storage/year-end-financial-statement.pdf?${Date.now()}`" target="_blank" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                                <span class="ml-3">View File</span>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
            <li class="col-span-1 bg-white rounded-lg border border-blue-200 divide-y divide-gray-200">
                <div class="w-full flex items-center text-center justify-center p-6 space-x-6">
                    <h3 class="text-gray-900 text-xl font-medium">PYCO By-Laws</h3>
                </div>
                <div>
                    <div class="-mt-px flex divide-x divide-gray-200">
                        <div class="w-0 flex-1 flex">
                            <a :href="`/storage/pyco-bylaws.pdf?${Date.now()}`" target="_blank" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                                <span class="ml-3">View File</span>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
            <li class="col-span-1 bg-white rounded-lg border border-blue-200 divide-y divide-gray-200">
                <div class="w-full flex items-center text-center justify-center p-6 space-x-6">
                    <h3 class="text-gray-900 text-xl font-medium">PYCO Articles of Incorporation</h3>
                </div>
                <div>
                    <div class="-mt-px flex divide-x divide-gray-200">
                        <div class="w-0 flex-1 flex">
                            <a :href="`/storage/pyco-articles-of-incorporation.pdf?${Date.now()}`" target="_blank" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                                <span class="ml-3">View File</span>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
            <li class="col-span-1 bg-white rounded-lg border border-blue-200 divide-y divide-gray-200">
                <div class="w-full flex items-center text-center justify-center p-6 space-x-6">
                    <h3 class="text-gray-900 text-xl font-medium">PYCO Marketing Plan</h3>
                </div>
                <div>
                    <div class="-mt-px flex divide-x divide-gray-200">
                        <div class="w-0 flex-1 flex">
                            <a :href="`/storage/pyco-marketing-plan.pdf?${Date.now()}`" target="_blank" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                                <span class="ml-3">View File</span>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    components: {Layout},
    metaInfo() {
        return {
            title: `Home`,
        }
    },
}
</script>
